import { Agents } from './Agents';
import { ClientSource } from './ClientSource';
import { CountryNamesByCode } from './Country';
import { filterOptions } from './FilterOptions';
import * as CRM from './CRM';
import { Icp } from './Icp';
import { Mcp } from './Mcp';
import { Notifications } from './Notifications';
import { SearchPaging } from './SearchPaging';
import { Teammate } from './Teammate';

export const Constants = {
  Notifications,
  Agents,
  CRM,
  Icp,
  Mcp,
  ClientSource,
  CountryNamesByCode,
  filterOptions,
  SearchPaging,
  Teammate,
};
